export * from './FAQ';
export { default as FAQ } from './FAQ';
